// @flow strict

import * as React from 'react';
import { Button, Link } from '../../../internal/Button';
import PardotDialog from '../../../internal/PardotDialog';

const ctaVariantMap = {
  Low: { Default: 'GhostInverse', Link: 'Underline', Outlined: 'Default', Accent: 'Accent' },
  Medium: { Default: 'GhostInverse', Link: 'Underline', Outlined: 'Default', Accent: 'Accent' },
  High: { Default: 'GhostInverse', Link: 'UnderlineHigh', Outlined: 'Default', Accent: 'Accent' },
  Dark: {
    Default: 'GhostInverseWhite',
    Link: 'UnderlineDark',
    Outlined: 'GhostInverseWhite',
    Accent: 'Bronze',
  },
};

type CtaHrefType = {|
  ctaHref: string,
|};

type PardotFormType = {|
  pardotFormUrl: string,
  pardotFormTitle: string,
|};

type CtaLinkType = CtaHrefType | PardotFormType;

export type CtaButtonType = {|
  text: string,
  variant: 'Default' | 'Link' | 'Outlined' | 'Accent',
  ...CtaLinkType,
|};

type CtaButtonPropsType = {|
  ...CtaButtonType,
  background: 'Low' | 'Medium' | 'High' | 'Dark',
  className?: string,
|};

const CtaButton = (props: CtaButtonPropsType) => {
  const [dialogOpen, toggleDialog] = React.useState(false);
  const onClick = () => {
    toggleDialog(true);
  };

  return (
    <>
      {props.ctaHref && (
        <Link
          className={props.className}
          href={props.ctaHref}
          variant={ctaVariantMap[props.background][props.variant]}
        >
          {props.text}
        </Link>
      )}
      {props.pardotFormUrl && (
        <>
          <Button
            className={props.className}
            onClick={onClick}
            variant={ctaVariantMap[props.background][props.variant]}
          >
            {props.text}
          </Button>
          {dialogOpen && (
            <PardotDialog
              formTitle={props.pardotFormTitle}
              formUrl={props.pardotFormUrl}
              onToggle={toggleDialog}
            />
          )}
        </>
      )}
    </>
  );
};

CtaButton.defaultProps = {
  variant: 'Default',
};

export default CtaButton;
